import { createPortal } from 'react-dom'

const PaginationPortal = ({ children }) => {
    const mount = document.getElementById('pagination-portal-root')

    if (!mount) return null

    return createPortal(children, mount)
}

export default PaginationPortal
